import React, { PropsWithChildren } from 'react';

import classes from './MainContent.module.scss';

interface Props extends PropsWithChildren {
    className?: string;
}

export const MainContent = ({ children, className }: Props) => {
    return (
        <div data-testid={'main-content'} className={[classes.mainContent, className].filter(Boolean).join(' ')}>
            {children}
        </div>
    );
};
